import React, { Component, Props, Dispatch, Fragment } from 'react';
import { CourseSubNavigateType, IMainCourseMenuContentProps } from '../../../models/pages/main-menu';
import { UserType } from '../../../models/pages/login.d';
import Translator from '../../../core/i18n';
import { Log, Level, Logger } from 'ng2-logger';
import * as Actions from '../../../store/actions/mainMenu';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../../models/action/core';
import Loading from '../../../components/loading/loading';
import { Route, Redirect } from 'react-router';
import NavLink from 'react-bootstrap/NavLink';
import { string } from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { MainMenuParameters } from '../types.d';
import { Common } from '../../../core/common';
import { SecureImage } from '../../../components/core/secureImage';
import ProgressCircle from '../../../components/progress-circle/progress-circle';
import ContentLoader from 'react-content-loader';
import ReactGA from 'react-ga4';

const T = Translator.create();
const _logger = Log.create('courseSubNavigation.tsx');
let _common: Common;

export class CourseSubNavigation extends React.Component<IMainCourseMenuContentProps, any> {
    public State = {
        classId: string,
        courseId: string,
        redirect: false
    };

    constructor(props: IMainCourseMenuContentProps) {
        super(props);
        this.state = {
            navigate: false
        };
        _common = new Common();
    }

    public componentDidMount = () => {
        if (
            this.props.courseSubNavigationTabParam === CourseSubNavigateType.teacherCourse.toString() ||
            this.props.courseSubNavigationTabParam === CourseSubNavigateType.archivedLessonsTeacher.toString() ||
            this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin 
        ) {
            this.props.dispatch(
                Actions.getMainMenuCourseContentData(
                    true,
                    this.props.courseSubNavigationTabParam ? this.props.courseSubNavigationTabParam : CourseSubNavigateType.teacherCourse.toString(),
                    this.props.tabActiveStatus!,
                    'getMainMenuCourseContentData',
                    'get'
                )
            );
        } else {
            this.props.dispatch(
                Actions.getMainMenuCourseContentData(false, this.props.courseSubNavigationTabParam!, this.props.tabActiveStatus!)
            );
        }
    };

    public onErrorCourseLogo = (event: any) => {
        event.target.src = _common.GetDefaultImages('_coursecard');
    };

    public navigateToUrl = () => {
        
        ReactGA.event({
            category: window.location.host,
            action: 'G_MY_ALL_LESSONS_CLICKED',
            label:'G_MY_ALL_LESSONS_CLICKED', 
            nonInteraction: true, 
          });
        this.closeMainMenu();
        this.props.history.push(window.appSettings.DEFAULT_URL + '/u/mycourse');
    };

    public closeMainMenu  = (param?: any) => {
            if ( param==1) 
            {
                ReactGA.event({
                    category: window.location.host,
                    action: 'G_MY_LESSONS_X_LESSON',
                    label:'G_MY_LESSONS_X_LESSON', 
                    nonInteraction: true, 
                  });
            }
        const courseMenu = document.getElementById('courseNavigationn');
        const courseMenuLink = document.getElementsByClassName(MainMenuParameters.myCourses);
        if (courseMenu && courseMenuLink) {
            courseMenu.classList.add('fadeOut');
            courseMenu.classList.remove('fadeIn');
            courseMenu.classList.remove('displayBlock');
            courseMenu.classList.add('displayNone');
            courseMenu.classList.remove('active');
        }
    };

    public mainMenuCourseContent(param: any)
    {
        return (param.mainMenuCourseContent && param.mainMenuCourseContent.length > 0);
    }

    public cNameCondition(param: any)
    {
        return (param.teachers && param.teachers.length > 40 ? param.teachers.slice(0, 40) + '...' : param.teachers);
    }

    shouldComponentUpdate(nextProps:any, nextState:any) { 
        if (nextProps.mainMenuCourseContent !== this.props.mainMenuCourseContent) { 
          return true; 
        } else { 
          return false; 
        } 
    }

    getCourseLink(c:any) {
        return `/almsp/u/course?classId=${c.classId}&activityId=${c.courseId}&type=1`;
    }


    public render() {
        const loadingSpaces = 80;
        const courseLimit = 5;

        return (
            <div id="menu1" className="lecture-bars tab-pane active fadeIn animated">
                <div className="row">
                    <Loading spinnerId={'getMainMenuCourseContentData'} height={240} width={'100%'}>
                        <div style={{ backgroundColor: '#fbfaf6', height: '100%' }}>
                            <ContentLoader
                                speed={2}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                style={{ width: '100%', height: '100%' }}
                                preserveAspectRatio="xMinYMin meet"
                            >
                                <rect x="20" y={0} rx="3" ry="3" width="7.2%" height="68" />
                                <rect x="130" y={0} rx="3" ry="3" width="40%" height="68" />
                                <rect x="51%" y={0} rx="3" ry="3" width="7.2%" height="68" />
                                <rect x="58.7%" y={0} rx="3" ry="3" width="40%" height="68" />

                                <rect x="20" y={0 + (loadingSpaces)} rx="3" ry="3" width="7.2%" height="68" />
                                <rect x="130" y={0 + (loadingSpaces)} rx="3" ry="3" width="40%" height="68" />
                                <rect x="51%" y={0 + (loadingSpaces)} rx="3" ry="3" width="7.2%" height="68" />
                                <rect x="58.7%" y={0 + (loadingSpaces)} rx="3" ry="3" width="40%" height="68" />

                                <rect x="20" y={0 + (loadingSpaces) * 2} rx="3" ry="3" width="7.2%" height="68" />
                                <rect x="130" y={0 + (loadingSpaces) * 2} rx="3" ry="3" width="40%" height="68" />
                                <rect x="51%" y={0 + (loadingSpaces) * 2} rx="3" ry="3" width="7.2%" height="68" />
                                <rect x="58.7%" y={0 + (loadingSpaces) * 2} rx="3" ry="3" width="40%" height="68" />
                            </ContentLoader>
                        </div>
                    </Loading>

                    <div id="getMainMenuCourseContentData_Content_Flex" style={{ width: '100%', display: 'flex', flexWrap: 'wrap' }}>
                        {(this.mainMenuCourseContent(this.props))?(<Fragment>
                                {this.props.mainMenuCourseContent?.slice(0, courseLimit).map((c, index) => {
                                    return (
                                        <div key={Math.random() * 10000} className="col-lg-6">
                                    <div className="media">
                                        <div className="course_info">
                                            <Link 
                                                onClick={event => this.closeMainMenu(1)}
                                                to={this.getCourseLink(c)}
                                            >
                                                <SecureImage imageUrl={c.logoUrl!} style={{borderRadius: "50%"}} class={'course-icon'} imgType={'smallCourse'} />
                                            </Link>
                                        </div>
                                        <div className="media-body d-flex justify-content-between" style={{ margin: '-6px 0' }}>
                                            <div>
                                                <Link 
                                                    onClick={event => this.closeMainMenu(1)}
                                                    to={this.getCourseLink(c)}
                                                >
                                                    {c.name && c.name.length > 40 ? (
                                                        <div className="list-icons">
                                                            <a className="lead-tooltip">
                                                                <h6 className="text-truncate">{c.name.slice(0, 40) + '...'}</h6>
                                                            </a>
                                                        </div>
                                                    ) : (
                                                        <h6 className="text-truncate">{c.name}</h6>
                                                    )}
                                                </Link>
                                                <Link 
                                                    onClick={event => this.closeMainMenu(1)}
                                                    to={this.getCourseLink(c)}
                                                >
                                                    <span>{this.cNameCondition(c)}</span>
                                                </Link>
                                            </div>
                                            {this.props.userType === UserType.Teacher ? '' : <ProgressCircle percent={c.progress} />}
                                        </div>
                                    </div>
                                </div>
                                    );
                                })}
                                <div className="col-lg-6" onClick={this.navigateToUrl}>
                                    <div className="media without-image">
                                        <div className="media-body">
                                            <h6 className="text-truncate">
                                                {T.t('r_goto_my_courses')}{' '}
                                                {window.courseNavigationSelectedItemCount > courseLimit ? (
                                                    <span className="count" style={{marginInlineStart: "1rem"}}>
                                                        +{window.courseNavigationSelectedItemCount - courseLimit}
                                                    </span>
                                                ) : null}
                                            </h6>
                                            <i className="material-icons lesson-header-image">arrow_forward</i>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        ) : (
                            <div style={{ width: '100%', height: ' 100%', textAlign: 'center' }}>
                                <h5 style={{ paddingTop: '30px' }}>{T.t('r_main_navigation_course_none_record_message')}</h5>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IMainCourseMenuContentProps): IMainCourseMenuContentProps => {
    const mainMenuContent: any = {
        mainMenuCourseContent: state.mainMenuRoot.mainMenuCourseContent,
        mainMmenuCourseContentIsLoaded: state.mainMenuRoot.mainMmenuCourseContentIsLoaded
    };

    if (!state) {
        return ownProps;
    }

    const newProps: IMainCourseMenuContentProps = Object.assign({}, ownProps, {
        menuPanelItems: state.mainMenuRoot.menuPanelItems,
        mainMenuCourseContent: state.mainMenuRoot.mainMenuCourseContent,
        courseSubNavigationTabParam: state.mainMenuRoot.courseSubNavigationTabParam,
        tabActiveStatus: state.mainMenuRoot.tabActiveStatus,
        mainMmenuCourseContentIsLoaded: state.mainMenuRoot.mainMmenuCourseContentIsLoaded,
        userType: state.login.identitiy.userType
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.mainMenuRoot.mainMenuCourseContent === prev.mainMenuRoot.mainMenuCourseContent;
    return ret;
};

const CCourseSubNavigation = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CourseSubNavigation);

export default withRouter(CCourseSubNavigation);
